<span *ngIf="Visible" class="external-integration-badge" [class.inline]="Inline" title="AMA / Autenticação.Gov"
    i18n-title=":@@consumer_request_form.ama_source">
    <img *ngIf="IconSrc; else fallback" [src]="IconSrc" alt="" />
    <ng-template #fallback><ion-icon name="shield-checkmark-outline"></ion-icon></ng-template>
</span>
